var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLawyers = function SvgLawyers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#0074C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.679 45H51.6379C51.6379 45 49 51.2684 49 55.4918C49 59.7152 51.6379 65.9836 51.6379 65.9836H60.8705C60.8705 65.9836 59.6154 71.543 59.5516 75.1639C59.4787 79.2925 60.8705 85.6557 60.8705 85.6557H74.0599V205L179.576 177.459V85.6557H191.446C191.446 85.6557 192.838 79.2925 192.765 75.1639C192.701 71.543 191.446 65.9836 191.446 65.9836H200.679C200.679 65.9836 201.937 59.3666 201.998 55.4918C202.066 51.1089 200.679 45 200.679 45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8227 90.9004C98.7364 90.9004 101.098 93.2491 101.098 96.1463V184.014C101.098 186.912 98.7364 189.26 95.8227 189.26C92.9089 189.26 90.5469 186.912 90.5469 184.014V96.1463C90.5469 93.2491 92.9089 90.9004 95.8227 90.9004Z",
    fill: "#0074C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.607 90.9004C118.521 90.9004 120.883 93.2491 120.883 96.1463V178.769C120.883 181.666 118.521 184.015 115.607 184.015C112.693 184.015 110.331 181.666 110.331 178.769V96.1463C110.331 93.2491 112.693 90.9004 115.607 90.9004Z",
    fill: "#0074C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.709 90.9004C139.623 90.9004 141.985 93.2491 141.985 96.1463V172.212C141.985 175.109 139.623 177.458 136.709 177.458C133.796 177.458 131.434 175.109 131.434 172.212V96.1463C131.434 93.2491 133.796 90.9004 136.709 90.9004Z",
    fill: "#0074C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.812 90.9004C160.726 90.9004 163.088 93.2491 163.088 96.1463V166.966C163.088 169.863 160.726 172.212 157.812 172.212C154.898 172.212 152.536 169.863 152.536 166.966V96.1463C152.536 93.2491 154.898 90.9004 157.812 90.9004Z",
    fill: "#0074C8"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLawyers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lawyers.e3fe081b.svg";
export { ForwardRef as ReactComponent };